<template>
  <div>
    <b-row
      v-if="sectionIds.length"
      class="search-block mb-3 mt-1"
    >
      <b-col
        xl="4"
        lg="6"
        md="12"
      >
        <searcher-module
          ref="searcherModule"
          name="laboratorySearcher"
          :error-message="$tc('laboratory.error.validIdentifier')"
          is-current-disabled
          :default-search-type="'general'"
          subportion-search
          portion-search
          sample-search
          @subportionSearch="onSubportionSearch($event)"
          @portionSearch="onPortionSearch($event)"
          @sampleSearch="onSampleSearch($event)"
        />
      </b-col>
    </b-row>
    <div
      v-if="selectedOption"
      class="laboratory-grid"
    >
      <vt-side-panel :visible="toggleAdditionalSidepanel">
        <additional-sidepanel
          ref="additionalSidepanel"
          @closeAdditionalSidepanel="closeAdditionalSidepanel"
        />
      </vt-side-panel>
      <vt-side-panel :visible="toggleMacroSidepanel">
        <macro-sidepanel
          v-if="selectedSample"
          ref="additionalMacroSidepanel"
          :lab-id="labId"
          :cas-id="selectedElementCaseId"
          :sample="selectedSample"
          @closeMacroSidepanel="closeMacroSidepanel"
          @showSynopticModal="showSynopticModal"
          @showTextModal="showTextModal"
        />
      </vt-side-panel>
      <div class="grid-container">
        <grid-header
          :qa="selectedOption.id"
          :gridtitle="selectedOption && !selectedOption.elementWithoutOperation ? selectedOption.label : ''"
          :gridsubtitle="msgSelectedRows"
          class="d-flex flex-md-row flex-sm-column"
        >
          <div class="d-flex align-items-center my-sm-2 my-md-0">
            <grid-display-options
              v-if="gridApi"
              :ui-component="displayOptionsUiComponent"
              @changedPageSize="changedPageSize($event)"
              @changedMode="changedMode($event)"
            />
            <div class="d-flex align-items-center">
              <!-- TODO: Los iconos de citología son los siguientes, tienen que salir siempre que estemos en un proceso de Citología,
                                     hasta darle lógica les pongo la clase "d-none" para ocultarlos -->
              <!--<div
                      class="pr-0 d-flex align-items-center"
                  >
                      <b-button
                          v-testing="'macroscopy'"
                          v-tooltip="$t('laboratory.content.macroscopy')"
                          class="d-none btn btn__icon btn__icon&#45;&#45;primary mx-3 p-0 btn-secondary"
                          @click="toggleMacroSidepanel = !toggleMacroSidepanel"
                      >
                          <i class="fas fa-align-justify"  aria-hidden="true"/>
                      </b-button>
                      <b-button
                          v-testing="'create-subsample'"
                          v-tooltip="$t('laboratory.content.createSubsample')"
                          class="d-none btn btn__icon btn__icon&#45;&#45;primary mx-3 p-0 btn-secondary"
                          style="position:relative"
                      >
                          <i class="far fa-prescription-bottle"  aria-hidden="true"/>
                          <i
                              class="far fa-plus"
                              style="position:absolute;bottom:3px;font-size:10px"
                           aria-hidden="true"/>
                      </b-button>
                      <b-button
                          v-testing="'print-labels'"
                          v-tooltip="$t('laboratory.content.printSampleTag')"
                          class="d-none btn btn__icon btn__icon&#45;&#45;primary mx-3 p-0 btn-secondary"
                      >
                          <i class="far fa-ticket-alt"  aria-hidden="true"/>
                      </b-button>
                  </div>-->

              <div class="pr-0 d-flex align-items-center">
                <div
                  class="vertical-divider mr-3 ml-0"
                />
                <!-- TODO: Cancellation front development required -->
                <b-button
                  v-if="false"
                  v-tooltip="$tc('global.cancellation.cancelElements')"
                  class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
                  @click="openCancellationModalForm()"
                >
                  <i
                    class="far fa-times-circle"
                    aria-hidden="true"
                  />
                </b-button>
                <b-button
                  v-testing="'instrument'"
                  v-tooltip="$tc('global.instrument', 2)"
                  :disabled="!canAddDevice"
                  class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
                  @click="openDevicesModalForm()"
                >
                  <i
                    class="icon-instrument"
                    aria-hidden="true"
                  />
                </b-button>
                <b-button
                  v-testing="'assays'"
                  v-tooltip="$tc('global.technique', 2)"
                  v-shortkey="['alt', 'a']"
                  class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
                  :disabled="disabledShowTechModal"
                  @shortkey.prevent="showTechModal"
                  @click.prevent="showTechModal"
                >
                  <i
                    class="fas fa-flask"
                    aria-hidden="true"
                  />
                </b-button>
                <b-button
                  v-tooltip="$t('component.manualShipment.manualShipment')"
                  qa="laboratory-grid-manual-shipment-button"
                  class="btn__icon btn__icon--primary mx-1"
                  :disabled="!selectedRows.length"
                  @click="showManualShipmentModal"
                >
                  <i
                    aria-hidden="true"
                    class="far fa-box"
                  />
                </b-button>
                <b-button
                  id="cleanFilters"
                  v-testing="'clean'"
                  v-tooltip="$t('global.cleanFilter')"
                  v-shortkey="['ctrl', 'alt', 'f']"
                  class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
                  @shortkey.prevent="cleanFilters"
                  @click="cleanFilters"
                >
                  <i
                    class="far fa-filter"
                    aria-hidden="true"
                  />
                </b-button>

                <vt-report-export-buttons
                  source="laboratory-grid"
                  :export-report="exportReport"
                />

                <b-button
                  v-if="canUndoLastOperationOfSelectedSidebarOption"
                  v-testing="'undo-action'"
                  v-tooltip="$t('laboratory.content.undoAction')"
                  v-shortkey="['ctrl', 'arrowup']"
                  :disabled="!canUndoLastOperationOfSelectedElements"
                  class="laboratory-button laboratory-button--back mr-2 p-0 flex-row-center"
                  @shortkey.prevent="showUndoActionConfirmationModal(null)"
                  @click="showUndoActionConfirmationModal(null)"
                >
                  <i
                    class="fas fa-arrow-circle-left lab-action"
                    aria-hidden="true"
                  />
                </b-button>
                <b-button
                  v-if="canProcessElementsOfSelectedOption"
                  v-testing="'apply-action'"
                  v-tooltip="$t('laboratory.content.processAction')"
                  v-shortkey="['ctrl', 'arrowdown']"
                  :disabled="!selectedRows.length"
                  class="laboratory-button laboratory-button--next mr-1 p-0 flex-row-center"
                  @shortkey.prevent="applyActionOnSelectedElements(selectedOption.actionUrl)"
                  @click="applyActionOnSelectedElements(selectedOption.actionUrl)"
                >
                  <i
                    class="fas fa-arrow-circle-right lab-action"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </div>
          </div>
        </grid-header>

        <vt-grid
          ref="vtGrid"
          :key="`${rowModel}-${selectedOption.id}`"
          v-testing="'elements'"
          class="laboratory-sample-grid"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :component-code="uiComponent"
          :component-id="componentId"
          :row-model-type="rowModel"
          :autosize-columns="autoSizeGridColumns"
        />
      </div>
      <modal-wrapper ref="addFilterModal">
        <add-custom-filter-modal id="addFilterModal" />
      </modal-wrapper>
      <print-component ref="printComponent" />
      <modal-wrapper ref="incidentModalTreeWrapper">
        <common-incident-modal-tree @incident-added="updateRowData()" />
      </modal-wrapper>
      <modal-wrapper ref="incidentFormModal">
        <incident-form-modal
          id="incidentFormModal"
          :core-entity="selectedOption.type.toUpperCase()"
          @incident-added="updateRowData()"
        />
      </modal-wrapper>
      <common-attachment-tree-modal
        v-if="patient"
        ref="attachmentTreeModal"
        :patient="patient"
        :laboratory-id="labId"
        @attachments-updated="updateRowData()"
      />
      <modal-wrapper ref="addFileModalWrapper">
        <add-file-modal
          id="addFileModal"
          ref="addFileModal"
          :attachment-entity-type="coreEntity"
          :entities-id-array="entitiesIdArray"
          @attachmentsAdded="updateRowData()"
        />
      </modal-wrapper>
      <modal-wrapper ref="modalAssaysView">
        <assays-view-modal
          v-if="casIdAssaysModal"
          :cas-id="casIdAssaysModal"
          :priority-cas="casPriorityAssaysModal"
          @subportionsAdded="getRowData()"
        />
      </modal-wrapper>
    </div>
    <div
      v-if="!selectedOption"
      class="laboratory-grid"
    >
      <div class="mw-100">
        <b-row>
          <b-col>
            <div class="empty-box header" />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col>
            <div
              class="d-flex align-items-center flex-column justify-content-center laboratory-empty-state"
            >
              <b-container>
                <div class="d-flex align-items-center flex-column">
                  <div class="d-none d-md-block">
                    <div class="d-flex align-items-center justify-content-center picture ">
                      <img
                        src="@/img/lab-empty-state.png"
                        alt="empty state"
                      >
                      <div class="circle" />
                    </div>
                  </div>
                  <h3 class="dark mt-4">
                    {{ $t('laboratory.emptyState.setupSections') }}
                  </h3>
                </div>
                <b-row class="w-100 px-5 mt-5 d-flex justify-content-around">
                  <b-col
                    xl="4"
                    lg="4"
                    md="6"
                    class="text-center mb-sm-3 mb-md-0"
                  >
                    <span>{{ $t('laboratory.emptyState.setupIcon') }}</span>
                  </b-col>
                  <b-col
                    xl="4"
                    lg="4"
                    md="6"
                    class="text-center"
                  >
                    <span>{{ $t('laboratory.emptyState.selectSectionsAndApplyActions') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mt-5 text-center">
                  <b-col
                    cols="12"
                    class="mt-5"
                  >
                    <span
                      class="ap-title ap-title__main"
                    >{{ $t('global.emptyState.needHelp') }}</span>
                  </b-col>
                  <b-col cols="12">
                    <b-button class="btn__icon btn__icon--primary main">
                      {{ $t('global.emptyState.userManual') }}
                    </b-button>
                    <b-button class="btn__icon btn__icon--primary main">
                      {{ $t('global.emptyState.technicalSupport') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <sample-batch-processing
      ref="sampleBatchProcessing"
      :is-grossing-route="false"
      @samplesUpdated="reloadGrid()"
    />
    <!-- TODO: Aplicar la prop "processor" o "cuttingDevice" según la sección -->
    <laboratory-devices-modal-form
      ref="laboratoryDevicesModalForm"
      :title="$tc('global.instrument', 2)"
      :options="selectedRows"
      :devices="instrumentOptions"
      :fixed-device="instrumentSelected"
      @device-applied="onDeviceApplied($event)"
    />
    <laboratory-cancellation-modal-form
      ref="laboratoryCancellationModalForm"
      :elements-number="selectedRows.length"
    />
    <modal-confirmation
      id="laboratoryConfirmationModal"
      ref="laboratoryConfirmationModal"
      :content="$t('laboratory.content.otherProcessConfirmation')"
    />
    <manual-shipment
      ref="manualShipment"
      :samples="selectedSamplesForManualShipment"
      :portions="selectedPortionsForManualShipment"
      :subportions="selectedSubportionsForManualShipment"
      :is-laboratory-desktop-pending-cut="selectedOptionIsPendingCut"
      @manualShipmentApplied="onManualShipmentApplied"
    />
    <modal-wrapper ref="reviewInfoModalWrapper">
      <review-info-modal
        :laboratory-id="labId"
        :case-id="selectedElementCaseId"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import LABORATORY_OPERATIONS from '@/modules/laboratoryModule/config/operations'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import CommonAttachmentTreeModal from '@/components/attachments/CommonAttachmentModalTree'
import CommonIncidentModalTree from '@/components/incidentsModal/CommonIncidentModalTree'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import Encoder from '@/utils/encoder'
import GridHeader from '@/components/GridHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import SearcherModule from '@/components/SearcherModule'
import { laboratoryGridPortionsColumnDefs } from '@/modules/laboratoryModule/grid/column-defs/laboratory-grid-portions.column-defs'
import { laboratoryGridSubportionsColumnDefs } from '@/modules/laboratoryModule/grid/column-defs/laboratory-grid-subportions.column-defs'
import { laboratoryGridSamplesColumnDefs } from '@/modules/laboratoryModule/grid/column-defs/laboratory-grid-samples.column-defs'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import AddCustomFilterModal from '@/components/customFilter/AddCustomFilterModal'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import store from './sideBar/laboratorySideBarStore'
import LaboratoryDynamicServices from '@/modules/laboratoryModule/services/laboratoryDynamicServices'
import { LaboratoryDatasource } from '@/modules/laboratoryModule/grid/laboratory-datasource'
import AssaysViewModal from '@/components/assays-view/components/modal/assays-view-modal.vue'
import AddFileModal from '@/components/AddFileModal'
import AdditionalSidepanel from '@/modules/laboratoryModule/AdditionalSidepanel'
import MacroSidepanel from '@/modules/laboratoryModule/MacroSidepanel'
import { isEmpty, cloneDeep, uniqBy } from 'lodash'
import GridDisplayOptions from '@/components/GridDisplayOptions'
import { ASSAY_STATES } from '@/api/resources/entityState/assay-state'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import SampleBatchProcessing from '@/modules/laboratoryModule/grid/SampleBatchProcessing'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import LaboratoryOptionGuardsMixin from '@/modules/laboratoryModule/mixins/LaboratoryOptionGuardsMixin'
import instrumentsMixin from '@/modules/laboratoryModule/mixins/instrumentsMixin'
import LaboratoryDevicesModalForm from '@/modules/laboratoryModule/form/LaboratoryDevicesModalForm'
import LaboratoryCancellationModalForm from '@/components/laboratory-cancellation-modal-form/laboratory-cancellation-modal-form.vue'
import { PortionOperation } from '@/api/operations/models/portion-operation'
import i18n from '@/lang/i18n'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'
import { AgGridColumnType, AgGridExportType, AgGridRowModelType } from '@/shared/models/ag-grid.model'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { GridUtils } from '@/shared/util/grid-utils'
import ManualShipment from '@/components/manual-shipment/manual-shipment.vue'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { SampleOperation } from '@/api/operations/models/sample-operation'
import ReviewInfoModal from '@/modules/diagnosisModule/views/form/modals/reviewModal/ReviewInfoModal'
import { ReviewHelper } from '@/modules/laboratoryModule/common/review-helper'
import apiExceptionType from '@/utils/apiExceptionType'
import { commonPortionService } from '@/api/services/common/portion/common-portion.service'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'

const ROW_HEIGHT_NORMAL = 40
const ROW_HEIGHT_COMPACT = 25
export default {
    name: 'LaboratoryGrid',
    components: {
        AddCustomFilterModal,
        AddFileModal,
        AdditionalSidepanel,
        AssaysViewModal,
        CommonAttachmentTreeModal,
        CommonIncidentModalTree,
        GridDisplayOptions,
        GridHeader,
        IncidentFormModal,
        LaboratoryDevicesModalForm,
        LaboratoryCancellationModalForm,
        MacroSidepanel,
        ManualShipment,
        ModalConfirmation,
        ReviewInfoModal,
        SampleBatchProcessing,
        SearcherModule,
        VtGrid
    },
    mixins: [
        LaboratoryOptionGuardsMixin,
        SampleOperationGuardMixin,
        IncidentOperationGuardMixin,
        instrumentsMixin,
        GridExportMixin
    ],
    props: {
        initMode: {
            type: Object,
            default: () => ({ value: 'compact', icon: 'fal fa-align-justify' })
        },
        initFilterModel: { type: Object, default: null },
        initSortModel: { type: Array, default: () => [] },
        initPaginator: { type: Object, default: null },
        initTabId: { type: Number, default: 0 }
    },
    data() {
        return {
            displayOptionsUiComponent: 'uicomponent.laboratory.laboratoryGrid',
            pageSize: 20,
            LABORATORY_OPERATIONS: LABORATORY_OPERATIONS,
            mode: this.initMode,
            casIdAssaysModal: null,
            casPriorityAssaysModal: null,
            selectedSample: null,
            patient: null,
            isPortion: true,
            selectedRows: [],
            toggleAdditionalSidepanel: false,
            toggleMacroSidepanel: false,
            showGrid: true,
            data: [],
            rowModel: AgGridRowModelType.SERVER_SIDE,
            store: store,
            gridApi: null,
            columnApi: null,
            encoder: new Encoder(),
            entitiesIdArray: [],
            coreEntity: null,
            updateTaskCountInterval: null
        }
    },
    computed: {
        selectedOptionIsPendingCut() {
            return this.selectedOption?.id === PortionOperation.CUT
        },
        selectedSamplesForManualShipment() {
            let samples = []
            if (this.selectedOption?.type === ENTITIES_LABORATORY.SAMPLE) {
                samples = this.selectedRows.length ? this.selectedRows.map(selectedRow => ({
                    caseId: selectedRow.caseStudy.casId,
                    sampleId: selectedRow.id,
                    label: selectedRow.sampleLabel
                })) : []
            }
            return samples
        },
        selectedPortionsForManualShipment() {
            let portions = []
            if (this.selectedOption?.typeAlt === ENTITIES_LABORATORY.PORTION) {
                portions = this.selectedRows.length ? uniqBy(this.selectedRows.map(selectedRow => ({
                    caseId: selectedRow.portion.sample.caseStudy.casId,
                    sampleId: selectedRow.portion.sample.samId,
                    portionId: selectedRow.portion.porId,
                    label: selectedRow.portion.porLabel
                })), 'portionId') : []
            } else if (this.selectedOption?.type === ENTITIES_LABORATORY.PORTION) {
                portions = this.selectedRows.length ? this.selectedRows.map(selectedRow => ({
                    caseId: selectedRow.sample.caseStudy.casId,
                    sampleId: selectedRow.sample.samId,
                    portionId: selectedRow.porId,
                    label: selectedRow.porLabel
                })) : []
            }
            return portions
        },
        selectedSubportionsForManualShipment() {
            let subportions = []
            if (this.selectedOption?.type === ENTITIES_LABORATORY.SUBPORTION || this.selectedOption?.typeAlt === ENTITIES_LABORATORY.SUBPORTION) {
                subportions = this.selectedRows.length ? this.selectedRows.map(selectedRow => ({
                    caseId: selectedRow.portion.sample.caseStudy.casId,
                    sampleId: selectedRow.portion.sample.samId,
                    portionId: selectedRow.portion.porId,
                    subportionId: selectedRow.supId,
                    label: selectedRow.supLabel
                })) : []
            }
            return subportions
        },
        autoSizeGridColumns() {
            return this.rowModel === AgGridRowModelType.SERVER_SIDE
        },
        canMarkSelectedOptionAsDepletedOrNonDepleted() {
            return (this.selectedOption.operation === LABORATORY_OPERATIONS.PARAFFINBLOCK_CUT.id ||
                this.selectedOption.operation === LABORATORY_OPERATIONS.PARAFFINBLOCK_ARCHIVE.id) &&
                this.$_canCutPortion()
        },
        canAddDevice() {
            return !this.selectedOption?.elementWithoutOperation && !!this.selectedRows.length && !!this.instrumentOptions.length
        },
        regex() {
            return this.$store.getters.regex
        },
        rowHeight() {
            if (this.mode.value === 'compact') {
                return ROW_HEIGHT_COMPACT
            }
            return ROW_HEIGHT_NORMAL
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                paginationPageSize: this.pageSize,
                paginationAutoPageSize: false,
                getContextMenuItems: this.getContextMenuItems,
                onRowClicked: this.onRowClicked,
                onRowDoubleClicked: this.onRowDoubleClicked,
                getRowHeight: () => this.rowHeight,
                pagination: true,
                onSortChanged: ({ api }) => api.deselectAll(),
                onFilterChanged: ({ api }) => api.deselectAll(),
                sideBar: gridSideBarConfig,
                autoGroupColumnDef: {
                    headerName: 'Consoles', // custom header name for group
                    pinned: 'left', // force pinned left. Does not work in columnDef
                    cellRendererParams: {
                        suppressCount: true // remove number in Group Column
                    }
                }
            }
        },
        columnDefs() {
            let columns = []
            switch (this.selectedOption.type) {
            case ENTITIES_LABORATORY.PORTION:
                columns = cloneDeep(laboratoryGridPortionsColumnDefs)
                break
            case ENTITIES_LABORATORY.SUBPORTION:
                columns = cloneDeep(laboratoryGridSubportionsColumnDefs)
                break
            case ENTITIES_LABORATORY.SAMPLE:
                columns = cloneDeep(laboratoryGridSamplesColumnDefs)
                break
            }

            const hasSelectedOptionPortionDepletedColumn = [
                PortionOperation.CUT,
                PortionOperation.ARCHIVE
            ].includes(this.selectedOption.id)
            const portionDepletedColumnField =
                this.selectedOption.id === PortionOperation.CUT ? 'portion.depleted' : 'depleted'
            if (hasSelectedOptionPortionDepletedColumn &&
                !columns.find(column => column.field === portionDepletedColumnField)) {
                columns.push({
                    headerName: i18n.tc('grid.detail.depletedBlock'),
                    field: portionDepletedColumnField,
                    type: AgGridColumnType.CHECK_ICON,
                    exportType: AgGridExportType.BOOLEAN,
                    width: 135
                })
            }

            const hasSelectedOptionArchiveLocationColumn = [
                SubportionOperation.UNARCHIVE_TO_SCAN,
                SubportionOperation.UNARCHIVE_TO_STAIN,
                PortionOperation.UNARCHIVE_TO_REMAKE,
                PortionOperation.UNARCHIVE_TO_CUT,
                SampleOperation.UNARCHIVE
            ].includes(this.selectedOption.id)
            const archiveLocationColumnField = 'archivingLocation'
            if (hasSelectedOptionArchiveLocationColumn &&
                !columns.find(column => column.field === archiveLocationColumnField)) {
                columns.push({
                    headerName: i18n.tc('archive.grid.archiveLocation'),
                    colId: 'locationLabel',
                    field: archiveLocationColumnField,
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    width: 135
                })
            }

            const hasSelectedOptionSearchProcessedSamples =
                this.selectedOption.url === 'searchProcessedSamples'
            const currentLaboratoryColumnField = 'currentLaboratory.labName'
            if (hasSelectedOptionSearchProcessedSamples &&
                !columns.find(column => column.field === currentLaboratoryColumnField)) {
                columns.push({
                    headerName: i18n.tc('global.laboratory'),
                    field: 'currentLaboratory.labName',
                    type: AgGridColumnType.LABORATORIES,
                    exportType: AgGridExportType.TEXT
                })
            }

            const hasSelectedOptionUnfinishedReview = this.hasSelectedOptionUnfinishedReview()
            if (hasSelectedOptionUnfinishedReview) {
                columns.push({
                    headerName: i18n.tc('diagnosis.labels.review'),
                    headerTooltip: i18n.tc('diagnosis.labels.pendingReview'),
                    field: 'hasUnfinishedReview',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.BOOLEAN,
                    filter: false,
                    hide: false,
                    width: 55,
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('far fa-tasks')
                    },
                    cellRenderer: ({ value }) => value === true ? '<i class="success far fa-check" aria-hidden="true"/>' : ''
                })
            }

            const hasUnauthorizedBillableConceptsColumnField = 'hasUnauthorizedBillableConcepts'
            if (
                ModuleOperationGuard.canAccessBilling &&
                !columns.find(column => column.field === hasUnauthorizedBillableConceptsColumnField)
            ) {
                columns.push({
                    type: AgGridColumnType.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS,
                    exportType: AgGridExportType.BOOLEAN,
                    field: hasUnauthorizedBillableConceptsColumnField,
                    flex: 1,
                    minWidth: 55
                })
            }

            return columns
        },
        displayedColumns() {
            return this.columnApi.getAllDisplayedColumns()
        },
        labId() {
            return this.$store.getters.labId
        },
        uiComponent() {
            if (this.selectedOption && !this.selectedOption.elementWithoutOperation) {
                return this.selectedOption.uicomponent
            }
            return null
        },
        componentId() {
            return this.selectedOption?.id?.toString()
        },
        selectedElementCaseId() {
            let caseId = null
            if (this.selectedRows.length === 1) {
                switch (this.selectedOption.type) {
                case ENTITIES_LABORATORY.PORTION:
                    caseId = this.selectedRows[0].sample.caseStudy.casId
                    break
                case ENTITIES_LABORATORY.SUBPORTION:
                    caseId = this.selectedRows[0].portion.sample.caseStudy.casId
                    break
                default:
                    caseId = this.selectedRows[0].caseStudy.casId
                }
            }
            return caseId
        },
        msgSelectedRows() {
            if (this.selectedRows.length) {
                const choice = this.selectedRows.length > 1 ? 2 : 1
                return `${this.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
            }
            return ''
        },
        canUndoLastOperationOfSelectedElements() {
            if (this.selectedRows.length) {
                if (this.selectedOption.typeAlt === ENTITIES_LABORATORY.PORTION) {
                    return this.selectedRows.every(element => element.portion.lastOperationCanBeUndone)
                } else {
                    return this.selectedRows.every(element => element.lastOperationCanBeUndone)
                }
            }
            return false
        },
        disabledShowTechModal() {
            return this.selectedRows.length !== 1
        }
    },
    watch: {
        selectedOption() {
            this.rowModel = AgGridRowModelType.SERVER_SIDE
            this.data = []
            this.selectedRows = []

            this.toggleAdditionalSidepanel = false
            this.toggleMacroSidepanel = false

            this.resetInstrumentsData()

            setTimeout(() => this.$refs.searcherModule?.focusInput(), 500)
        }
    },
    mounted() {
        this.$eventHub.$on('onModalStatesSuccessHide', this.onModalStatesSuccessHide)

        this.updateTaskCountInterval = this.$_setSummaryInterval(() => this.$eventHub.$emit('updateTaskCount'))
    },
    beforeDestroy() {
        this.$eventHub.$off('onModalStatesSuccessHide', this.onModalStatesSuccessHide)
        if (this.updateTaskCountInterval !== null) {
            clearInterval(this.updateTaskCountInterval)
        }
        store.setSelectedOption(null)
    },
    methods: {
        onModalStatesSuccessHide() {
            this.$nextTick(() => this.$refs.searcherModule.focusInput())
        },
        onManualShipmentApplied() {
            this.reloadGrid()
        },
        showManualShipmentModal() {
            this.$refs.manualShipment.show()
        },
        showInGlobalLocator(data) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                this.$eventHub.$emit('show-in-global-locator', data.porLabel)
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                this.$eventHub.$emit('show-in-global-locator', data.supLabel)
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                this.$eventHub.$emit('show-in-global-locator', data.sampleLabel)
            }
        },
        someOfSelectedElementsAreDepleted(elements) {
            let entityIsDepleted = null
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                entityIsDepleted = elements.some(element => element.depleted)
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                entityIsDepleted = elements.some(element => element.portion.depleted)
            }
            return entityIsDepleted
        },
        someOfSelectedElementsAreNonDepleted(elements) {
            let entityIsDepleted = null
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                entityIsDepleted = elements.some(element => !element.depleted)
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                entityIsDepleted = elements.some(element => !element.portion.depleted)
            }
            return entityIsDepleted
        },
        openDevicesModalForm() {
            this.$refs.laboratoryDevicesModalForm.show()
        },
        openCancellationModalForm() {
            this.$refs.laboratoryCancellationModalForm.show()
        },
        isResponsibleForGrossingValid(sample) {
            return this.$store.getters.userInformation?.personnel?.id === sample.grossingResponsible?.id
        },
        async processSamples(samples) {
            await this.$refs.sampleBatchProcessing.processSamples(samples, this.selectedOption)
        },
        onRowDoubleClicked(params) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                this.$router.push({
                    name: 'laboratorySampleView',
                    params: {
                        casId: params.data.caseStudy.casId,
                        samId: params.data.id
                    }
                })
            }
        },
        async showUndoActionConfirmationModal(elements) {
            const confirmation = await this.showConfirmationModalGlobal(this.$t('laboratory.content.askUndoActionConfirmation'))
            if (confirmation) {
                if (elements) {
                    await this.applyAction(this.getUndoUrlOfSelectedOption(), elements)
                } else if (this.selectedRows.length) {
                    await this.applyActionOnSelectedElements(this.getUndoUrlOfSelectedOption())
                }
            }
        },
        async onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()

            await this.loadInstrumentOptions(this.selectedRows)
        },
        showSynopticModal() {
            this.$refs['synopticModal'].show()
        },
        showTextModal() {
            this.$refs['templatesModal'].show()
        },
        async onRowClicked(params) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION || this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                let loadPortionInformation = null
                let dataToLoad = params.data
                const isSelectedOptionParaffinBlockCut = this.selectedOption.id === LABORATORY_OPERATIONS.PARAFFINBLOCK_CUT.id
                this.toggleAdditionalSidepanel = true
                if (isSelectedOptionParaffinBlockCut) {
                    loadPortionInformation = true
                    dataToLoad = params.data.portion
                } else {
                    loadPortionInformation = this.selectedOption.type === ENTITIES_LABORATORY.PORTION
                }
                if (loadPortionInformation) {
                    await this.$refs.additionalSidepanel.loadPortionInformation(
                        dataToLoad
                    )
                } else {
                    await this.$refs.additionalSidepanel.loadSubportionInformation(
                        dataToLoad
                    )
                }
            }
        },
        closeAdditionalSidepanel(value) {
            this.toggleAdditionalSidepanel = value
        },
        closeMacroSidepanel(value) {
            this.toggleMacroSidepanel = value
        },
        async cleanFilters() {
            if (!isEmpty(this.gridApi.getFilterModel())) {
                this._setFilterModel()
            }
        },
        async changedMode(selectedOption) {
            this.mode = selectedOption
            GridUtils.changeRowHeightGrid(this.gridApi, selectedOption.size)
        },
        changedPageSize(pageSize) {
            this.pageSize = pageSize
            this.gridApi.paginationSetPageSize(pageSize)
        },
        canAttachDocumentToElementsOfSelectedOption(selectedRow) {
            if (!selectedRow) {
                return false
            }
            switch (this.selectedOption.type) {
            case ENTITIES_LABORATORY.SAMPLE:
                return this.$_canAttachDocumentToSample() && this.$_canBeDocumentAttachedToSample(selectedRow)
            case ENTITIES_LABORATORY.PORTION:
                return this.$_canAttachDocumentToPortion() && this.$_canBeDocumentAttachedToPortion(selectedRow)
            case ENTITIES_LABORATORY.SUBPORTION:
                return this.$_canAttachDocumentToSubportion() && this.$_canBeDocumentAttachedToSubportion(selectedRow)
            default:
                return false
            }
        },
        hasSelectedOptionUnfinishedReview() {
            return [
                SampleOperation.REPROCESS,
                PortionOperation.MAKE,
                SubportionOperation.TO_SCANNER
            ].includes(this.selectedOption.id)
        },
        async mapAndShowReviewInfo(entity, entityType) {
            const reviewInfo = await ReviewHelper.mapReviewInfo(this.labId, entity, entityType)
            this.$refs.reviewInfoModalWrapper.show([reviewInfo.revision, reviewInfo.entity, reviewInfo.entityType])
        },
        getContextMenuItems(params) {
            if (!params?.node) {
                return []
            }
            const showUnfinishedReviewMenu = this.selectedRows.length === 1 &&
                this.hasSelectedOptionUnfinishedReview() &&
                this.selectedRows[0].hasUnfinishedReview
            return [
                {
                    name: this.$t('laboratory.content.processAction'),
                    action: () => this.applyAction(this.selectedOption.actionUrl, this.selectedRows),
                    cssClasses: this.canProcessElementsOfSelectedOption ? '' : ['not-show']
                },
                {
                    name: this.$t('laboratory.content.undoAction'),
                    action: () => this.showUndoActionConfirmationModal(this.selectedRows),
                    cssClasses:
                        this.canUndoLastOperationOfSelectedElements &&
                        this.canUndoLastOperationOfSelectedSidebarOption
                            ? '' : ['not-show']
                },
                {
                    name: this.$t('laboratory.grid.contextMenu.printLabel'),
                    action: () => this.printSubportionsLabels(this.selectedRows),
                    cssClasses:
                        this.$_canPrintSubportion() &&
                        this.selectedOption &&
                        ENTITIES_LABORATORY.SUBPORTION === this.selectedOption.type
                            ? '' : ['not-show']
                },
                {
                    name: this.$t('diagnosis.modals.reviewInformation'),
                    cssClasses: showUnfinishedReviewMenu ? '' : ['not-show'],
                    action: () => {
                        this.mapAndShowReviewInfo(params.node.data, this.selectedOption.type)
                    }
                },
                {
                    name: this.$t('laboratory.grid.contextMenu.viewIncidents'),
                    action: () => this.showIncidentModal(this.selectedRows[0]),
                    cssClasses: this.selectedRows.length === 1 ? '' : ['not-show']
                },
                {
                    name: this.$t('laboratory.grid.contextMenu.registerIncident'),
                    action: () => this.showIncidentFormModal(this.selectedRows[0]),
                    cssClasses:
                        this.selectedRows.length === 1 &&
                        this.$_canCreateIncident()
                            ? '' : ['not-show']
                },
                {
                    name: this.$tc('global.technique', 2),
                    action: () => this.showTechModal(),
                    cssClasses: this.selectedRows.length === 1 ? '' : ['not-show']
                },
                {
                    name: this.$t('laboratory.grid.contextMenu.viewAttach'),
                    action: () => this.showAttachmentModal(this.selectedRows[0]),
                    cssClasses: this.selectedRows.length === 1 ? '' : ['not-show']
                },
                {
                    name: this.$t('laboratory.grid.contextMenu.addAttach'),
                    action: () => this.showAddFileModal(this.selectedRows[0]),
                    cssClasses:
                        this.selectedRows.length === 1 &&
                        this.canAttachDocumentToElementsOfSelectedOption(this.selectedRows[0])
                            ? '' : ['not-show']
                },
                {
                    name: this.$t('grid.detail.markAsDepleted'),
                    action: () => this.markPortionAsDepleted(this.selectedRows),
                    cssClasses:
                        this.canMarkSelectedOptionAsDepletedOrNonDepleted &&
                        this.someOfSelectedElementsAreNonDepleted(this.selectedRows)
                            ? '' : ['not-show']
                },
                {
                    name: this.$t('grid.detail.markAsNonDepleted'),
                    action: () => this.markPortionsAsNonDepleted(this.selectedRows),
                    cssClasses:
                        this.canMarkSelectedOptionAsDepletedOrNonDepleted &&
                        this.someOfSelectedElementsAreDepleted(this.selectedRows)
                            ? '' : ['not-show']
                },
                {
                    name: this.$t('global.showInGlobalLocator'),
                    action: () => this.showInGlobalLocator(this.selectedRows[0]),
                    cssClasses: this.selectedRows.length === 1 ? '' : ['not-show']
                }
            ]
        },
        getEntityHierarchicalIds(entity) {
            switch (this.selectedOption.type) {
            case ENTITIES_LABORATORY.PORTION:
                return {
                    caseId: entity.sample.caseStudy.casId,
                    sampleId: entity.sample.samId,
                    portionId: entity.porId
                }
            case ENTITIES_LABORATORY.SUBPORTION:
                return {
                    caseId: entity.portion.sample.caseStudy.casId,
                    sampleId: entity.portion.sample.samId,
                    portionId: entity.portion.porId
                }
            case ENTITIES_LABORATORY.SAMPLE:
                return {
                    caseId: entity.caseId,
                    sampleId: entity.id
                }
            }
        },
        portionOrSubportionAreDepleted(entity) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                return entity.depleted
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                return entity.portion.depleted
            }
        },
        async markPortionAsDepleted(elements) {
            const entityIds = elements.map(element => this.getEntityHierarchicalIds(element))
            const [err] = await this.toCall(
                commonPortionService.markPortionsAsDepleted(this.labId, entityIds, false))
            if (err) {
                if (err.response?.data?.code === apiExceptionType.MARK_AS_DEPLETED_PORTION_HAS_SUBPORTIONS_PENDING_CUT) {
                    const shouldCancelSubportionsPendingCut = await this.showConfirmationModalGlobal(err.response.data.message)
                    if (shouldCancelSubportionsPendingCut) {
                        const [err2] = await this.toCall(
                            commonPortionService.markPortionsAsDepleted(this.labId, entityIds, true))
                        if (err2) {
                            this.showErrorModalGlobal()
                            return
                        }
                    } else {
                        return
                    }
                } else {
                    this.showErrorModalGlobal()
                    return
                }
            }
            this.showToastSuccessGlobal(this.$tc('laboratory.content.blockMarkAsDepletedSuccessfully'))
            if (this.selectedOptionIsPendingCut) {
                await this.reloadGrid()
            } else {
                await this.updateRowData(elements)
            }
        },
        async markPortionsAsNonDepleted(elements) {
            const entityIds = elements.map(element => this.getEntityHierarchicalIds(element))
            const [err] = await this.toCall(
                commonPortionService.markPortionsAsNonDepleted(this.labId, entityIds))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showToastSuccessGlobal(this.$tc('laboratory.content.blockMarkAsNonDepletedSuccessfully'))
            await this.updateRowData(elements)
        },
        async printSubportionsLabels(selectedSubportions) {
            const printSubportionsLabelsResponses = []
            for (const subportion of selectedSubportions) {
                const printSubportionsLabelsResponse = await this.$refs.printComponent.printSubportionsLabels(
                    this.labId,
                    subportion.portion.sample.caseStudy.casId,
                    subportion.portion.sample.samId,
                    subportion.portion.porId,
                    [subportion]
                )
                printSubportionsLabelsResponses.push(printSubportionsLabelsResponse)
            }
            if (printSubportionsLabelsResponses.some(response => response)) {
                await this.reloadGrid()
            }
        },
        showAddFileModal(params) {
            switch (this.selectedOption.type.toUpperCase()) {
            case ATTACHMENT_ENTITY_TYPE.SAMPLE:
                this.entitiesIdArray = [this.labId, params.caseStudy.casId, params.id]
                this.coreEntity = ATTACHMENT_ENTITY_TYPE.SAMPLE
                break
            case ATTACHMENT_ENTITY_TYPE.PORTION:
                this.entitiesIdArray = [this.labId, params.sample.caseStudy.casId, params.sample.samId, params.porId]
                this.coreEntity = ATTACHMENT_ENTITY_TYPE.PORTION
                break
            case ATTACHMENT_ENTITY_TYPE.SUBPORTION:
                this.entitiesIdArray = [
                    this.labId,
                    params.portion.sample.caseStudy.casId,
                    params.portion.sample.samId,
                    params.portion.porId,
                    params.supId
                ]
                this.coreEntity = ATTACHMENT_ENTITY_TYPE.SUBPORTION
                break
            }
            this.$refs.addFileModalWrapper.show()
        },
        showAttachmentModal(params) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                this.patient = { patId: params.sample.caseStudy.patientId }
                this.$nextTick(() => {
                    this.$refs.attachmentTreeModal.showPortion(params.porId)
                })
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                this.patient = { patId: params.portion.sample.caseStudy.patientId }
                this.$nextTick(() => {
                    this.$refs.attachmentTreeModal.showSubportion(params.supId)
                })
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                this.patient = { patId: params.caseStudy.patientId }
                this.$nextTick(() => {
                    this.$refs.attachmentTreeModal.showSample(params.id)
                })
            }
        },
        showIncidentModal(params) {
            let patientId, defaultOption
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                patientId = params.sample.caseStudy.patientId
                defaultOption = {
                    coreEntity: 'PORTION',
                    portionTypeEnum: params.portionType.portionTypeEnum,
                    casId: params.sample.caseStudy.casId,
                    samId: params.sample.samId,
                    porId: params.porId
                }
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                patientId = params.portion.sample.caseStudy.patientId
                defaultOption = {
                    coreEntity: 'SUBPORTION',
                    casId: params.portion.sample.caseStudy.casId,
                    samId: params.portion.sample.samId,
                    porId: params.portion.porId,
                    supId: params.supId
                }
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                patientId = params.caseStudy.patientId
                defaultOption = {
                    coreEntity: 'SAMPLE',
                    casId: params.caseStudy.casId,
                    samId: params.id
                }
            }
            this.$refs.incidentModalTreeWrapper.show([defaultOption, patientId])
        },
        showIncidentFormModal(params) {
            let entityInformation
            if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                entityInformation = {
                    coreEntity: 'PORTION',
                    porId: params.porId,
                    samId: params.sample.samId,
                    casId: params.sample.caseStudy.casId
                }
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                entityInformation = {
                    coreEntity: 'SUBPORTION',
                    supId: params.supId,
                    porId: params.portion.porId,
                    samId: params.portion.sample.samId,
                    casId: params.portion.sample.caseStudy.casId
                }
            } else if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                entityInformation = {
                    coreEntity: 'SAMPLE',
                    samId: params.id,
                    casId: params.caseStudy.casId
                }
            }
            this.$refs.incidentFormModal.show([null, entityInformation])
        },

        async getSubportionsPendingSlide(element) {
            const response =
                await this.$_toCallUnique(
                    LaboratoryDynamicServices.getSubportionsPendingSlide(
                        this.labId,
                        element.sample.caseStudy.casId,
                        element.sample.samId,
                        element.porId,
                        this.sectionIds))
            return response?.content.filter(elem => elem.assayStatus.code === ASSAY_STATES.PENDING.code) ?? []
        },
        processSearch(operation, element) {
            const previousNodes = this.gridApi?.getRenderedNodes() ?? []
            let operationProp = ''
            switch (this.selectedOption?.type) {
            case ENTITIES_LABORATORY.PORTION:
                operationProp = 'porId'
                break
            case ENTITIES_LABORATORY.SUBPORTION:
                operationProp = 'supId'
                break
            default:
                operationProp = 'id'
                break
            }

            if (this.selectedOption?.id === operation || this.selectedOption?.idAlt === operation) {
                if (this.rowModel !== AgGridRowModelType.CLIENT_SIDE) {
                    this.$nextTick(() => {
                        this.data = [element]
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                } else {
                    const elementIsNotAdded =
                        (this.selectedOption.type === ENTITIES_LABORATORY.PORTION &&
                          this.data.findIndex(item => item.porId === element.porId) < 0) ||
                        (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION &&
                          this.data.findIndex(item => item.supId === element.supId) < 0) ||
                        (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE &&
                            this.data.findIndex(item => item.id === element.id) < 0)
                    if (elementIsNotAdded) {
                        this.data.push(element)
                        this.gridApi.setRowData(this.data)

                        this.$_keepSelectionGridWhenSearch(
                            this.gridApi,
                            element[operationProp],
                            previousNodes,
                            operationProp)
                    } else {
                        this.$_showWarningModal(this.$tc('laboratory.tracking.elementAlreadyAdded'))
                    }
                }
            } else {
                this.$refs.laboratoryConfirmationModal.ask(() => {
                    const optionToSelect = this.state.customOptions.find(
                        option => option.id === operation ||
                            option.idAlt === operation)
                    this.store.setSelectedOption(optionToSelect)

                    this.$nextTick(() => {
                        this.data = [element]
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                    if (this.gridApi) {
                        this.$_keepSelectionGridWhenSearch(
                            this.gridApi,
                            element[operationProp],
                            previousNodes,
                            operationProp)
                    }
                })
            }
        },
        async processCutSearch(operation, element) {
            const subportionsPending = await this.getSubportionsPendingSlide(element)

            if (operation !== this.selectedOption?.id) {
                await this.$refs.laboratoryConfirmationModal.ask(() => {
                    const optionToSelect = this.state.customOptions.find(option => option.id === operation)
                    this.store.setSelectedOption(optionToSelect)

                    this.$nextTick(() => {
                        this.data = subportionsPending
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                })
            } else {
                if (this.rowModel !== AgGridRowModelType.CLIENT_SIDE) {
                    this.$nextTick(() => {
                        this.data = subportionsPending
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                } else {
                    const subportionIds = this.data.map(dataElement => dataElement.supId)
                    const subportionsNotAlreadyAdded =
                        subportionsPending.filter(
                            subportion => !subportionIds.includes(subportion.supId))

                    if (!subportionsNotAlreadyAdded.length) {
                        this.$_showWarningModal(this.$tc('laboratory.tracking.elementAlreadyAdded'))
                        return
                    }

                    this.data = this.data.concat(subportionsNotAlreadyAdded)
                    this.gridApi.setRowData(this.data)
                    this.gridApi.refreshCells()
                    this.gridApi.selectAll()
                }
            }
        },
        async onSubportionSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    LaboratoryDynamicServices.getSubportionsSearchByLabel(
                        this.labId,
                        searchInformation.search,
                        this.sectionIds),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('laboratory.content.elementNotFound')
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.SUBPORTION,
                            entityValue: this.mapSubportionToBeUsedInGlobalSearchMultipleModal(entity.subportion),
                            laboratoryId: entity.subportion.portion.sample.caseStudy.laboratory?.labId
                        }))
                    const entityValueSelected =
                        await this.$_showMultiEntitySelection(
                            searchInformation.search,
                            foundEntities)

                    entitySelected = response.find(entity => entity.subportion.supId === entityValueSelected.supId)
                }

                const operation = entitySelected.laboratoryOperations[0]
                const subportion = entitySelected.subportion
                if (operation) {
                    this.processSearch(operation, subportion)
                } else {
                    this.store.setSelectedOption({
                        type: ENTITIES_LABORATORY.SUBPORTION,
                        elementWithoutOperation: true
                    })

                    this.$nextTick(() => {
                        this.data = [subportion]
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                }
            }
        },
        mapSubportionToBeUsedInGlobalSearchMultipleModal(subportion) {
            return {
                ...subportion,
                subportionLabel: subportion.supLabel,
                portion: {
                    ...subportion.portion,
                    portionLabel: subportion.portion.porLabel,
                    sample: {
                        ...subportion.portion.sample,
                        sampleLabel: subportion.portion.sample.samLabel,
                        caseStudy: {
                            ...subportion.portion.sample.caseStudy,
                            casenumber: subportion.portion.sample.caseStudy.casCasenumber
                        }
                    }
                }
            }
        },
        mapPortionToBeUsedInGlobalSearchMultipleModal(portion) {
            return {
                ...portion,
                portionLabel: portion.porLabel,
                sample: {
                    ...portion.sample,
                    sampleLabel: portion.sample.samLabel,
                    caseStudy: {
                        ...portion.sample.caseStudy,
                        casenumber: portion.sample.caseStudy.casCasenumber
                    }
                }
            }
        },
        async onPortionSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    LaboratoryDynamicServices.getPortionsSearchByLabel(
                        this.labId,
                        searchInformation.search,
                        this.sectionIds),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('laboratory.content.elementNotFound')
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.PORTION,
                            entityValue: this.mapPortionToBeUsedInGlobalSearchMultipleModal(entity.portion),
                            laboratoryId: entity.portion.sample.caseStudy.laboratory?.labId
                        }))
                    const entityValueSelected =
                        await this.$_showMultiEntitySelection(
                            searchInformation.search,
                            foundEntities)

                    entitySelected = response.find(entity => entity.portion.porId === entityValueSelected.porId)
                }

                const operation = entitySelected.laboratoryOperations[0]
                const portion = entitySelected.portion
                if (operation === LABORATORY_OPERATIONS.PARAFFINBLOCK_CUT.id) {
                    await this.processCutSearch(operation, portion)
                } else if (operation) {
                    this.processSearch(operation, portion)
                } else {
                    this.store.setSelectedOption({
                        type: ENTITIES_LABORATORY.PORTION,
                        elementWithoutOperation: true
                    })

                    this.$nextTick(() => {
                        this.data = [portion]
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                }
            }
        },
        async onSampleSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    LaboratoryDynamicServices.getSamplesSearchByLabel(
                        this.labId,
                        searchInformation.search,
                        this.sectionIds),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('laboratory.content.elementNotFound')
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.SAMPLE,
                            entityValue: entity.sample,
                            laboratoryId: entity.sample.currentLaboratory.labId
                        }))
                    const entityValueSelected =
                        await this.$_showMultiEntitySelection(
                            searchInformation.search,
                            foundEntities)

                    entitySelected = response.find(entity => entity.sample.id === entityValueSelected.id)
                }

                const operation = entitySelected.laboratoryOperations[0]
                const sample = entitySelected.sample
                if (operation) {
                    this.processSearch(operation, sample)
                } else {
                    this.store.setSelectedOption({
                        type: ENTITIES_LABORATORY.SAMPLE,
                        elementWithoutOperation: true
                    })

                    this.$nextTick(() => {
                        this.data = [sample]
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    })
                }
            }
        },

        applyActionOnSelectedElements(url) {
            this.applyAction(url, this.selectedRows)
        },
        async applyAction(url, selectedElements) {
            if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                await this.processSamples(selectedElements)
                return
            }
            const mappedElements = selectedElements.map(elem => {
                if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                    return this.getIdHierarchyFromPortion(elem)
                } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                    return this.getIdHierarchyFromSubportion(elem)
                }
            })
            const [err] = await this.toCall(
                LaboratoryDynamicServices.applyAction(
                    this.labId,
                    this.selectedOption.sectionId,
                    url,
                    mappedElements
                )
            )
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err, this.$t('laboratory.content.errorAction'))
                return
            }
            await this.reloadGrid()
            this.showSuccessModalGlobal(this.$t('laboratory.content.actionOk'))
        },
        async onDeviceApplied(deviceFixed) {
            this.instrumentSelected = deviceFixed
            await this.updateRowData()
        },

        async onGridReady(event) {
            this.gridApi = event.api
            this.columnApi = event.columnApi

            if (this.rowModel === AgGridRowModelType.SERVER_SIDE) {
                await this.getRowData(true)
            } else {
                this.gridApi.setRowData(this.data)
                this.gridApi.selectAll()
            }
        },
        async reloadGrid() {
            this.$eventHub.$emit('updateTaskCount')

            this.rowModel = AgGridRowModelType.SERVER_SIDE
            this.$nextTick(() => this.getRowData(true))
        },
        _setFilterModel() {
            if (this.selectedOption.filterModel) {
                this.gridApi.setFilterModel(this.selectedOption.filterModel)
            } else if (!this.selectedOption.filterModel && !isEmpty(this.gridApi.getFilterModel())) {
                this.gridApi.setFilterModel(null)
            }
        },
        async getRowData(deselectAll = false) {
            if (this.selectedOption && this.selectedOption.url) {
                if (deselectAll) {
                    this.gridApi.deselectAll()
                }

                this._setFilterModel()

                this.gridApi.setServerSideDatasource(
                    new LaboratoryDatasource(
                        this.labId,
                        this.selectedOption.url,
                        this.sectionIds))

                this.$nextTick(async () => {
                    if (this.$refs.vtGrid) {
                        await this.$refs.vtGrid.loadCustomConfig()
                        this.toggleAdditionalSidepanel = false
                    }
                })
            }
        },
        async _updateSampleRowData(element) {
            const response =
                await this.$_toCallSecure(
                    LaboratoryDynamicServices.getSamplesSearchByLabel(
                        this.labId,
                        element.sampleLabel,
                        this.sectionIds))
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    entitySelected = response.find(entity => entity.sample.id === element.id)
                }

                if (entitySelected) {
                    this.gridApi?.forEachNode(async (rowNode) => {
                        const sample = rowNode.data
                        if (sample?.id === element.id) {
                            rowNode.setData(entitySelected.sample)
                        }
                    })
                }
            }
        },
        async _updatePortionRowData(element) {
            const response =
                await this.$_toCallSecure(
                    LaboratoryDynamicServices.getPortionsSearchByLabel(
                        this.labId,
                        element.porLabel,
                        this.sectionIds))
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    entitySelected = response.find(entity => entity.portion.porId === element.porId)
                }

                if (entitySelected) {
                    this.gridApi?.forEachNode(async (rowNode) => {
                        const portion = rowNode.data
                        if (portion?.porId === element.porId) {
                            rowNode.setData(entitySelected.portion)
                        }
                    })
                }
            }
        },
        async _updateSubportionRowData(element) {
            const response =
                await this.$_toCallSecure(
                    LaboratoryDynamicServices.getSubportionsSearchByLabel(
                        this.labId,
                        element.supLabel,
                        this.sectionIds))
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    entitySelected = response.find(entity => entity.subportion.supId === element.supId)
                }

                if (entitySelected) {
                    this.gridApi?.forEachNode(async (rowNode) => {
                        const subportion = rowNode.data
                        if (subportion?.supId === element.supId) {
                            rowNode.setData(entitySelected.subportion)
                        }
                    })
                }
            }
        },
        async updateRowData(elements = this.selectedRows) {
            if (this.rowModel === AgGridRowModelType.CLIENT_SIDE) {
                for (const element of elements) {
                    if ('sampleType' in element) {
                        await this._updateSampleRowData(element)
                    } else if ('portionType' in element) {
                        await this._updatePortionRowData(element)
                    } else if ('subportionType' in element) {
                        await this._updateSubportionRowData(element)
                    }
                }

                // to update the selected rows with the last changes
                this.selectedRows = this.gridApi?.getSelectedRows()
                // hide side panel
                this.toggleAdditionalSidepanel = false
            } else {
                await this.getRowData(true)
            }
        },

        _getSelectedEntityIds() {
            return this.selectedRows.map(
                selectedRow => {
                    switch (this.selectedOption.type) {
                    case ENTITIES_LABORATORY.SAMPLE:
                        return selectedRow.id
                    case ENTITIES_LABORATORY.PORTION:
                        return selectedRow.porId
                    case ENTITIES_LABORATORY.SUBPORTION:
                        return selectedRow.supId
                    }
                })
        },
        _getSelectedOptionLabelFieldName() {
            switch (this.selectedOption.type) {
            case ENTITIES_LABORATORY.SAMPLE:
                return 'sampleLabel'
            case ENTITIES_LABORATORY.PORTION:
                return 'porLabel'
            case ENTITIES_LABORATORY.SUBPORTION:
                return 'supLabel'
            }
        },
        exportReport(exportType) {
            // dynamic barcode export
            if (this.selectedOption.gridExportWithBarcode && this.columnApi) {
                const barcodeField =
                    this.columnApi.getAllGridColumns()
                        .map(column => column.getColDef())
                        .find(exportedColDef => exportedColDef.field === this._getSelectedOptionLabelFieldName())
                if (barcodeField) {
                    barcodeField.useForGeneratingBarcodeInExports = true
                }
            }

            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return LaboratoryDynamicServices.exportTo(
                    this.labId,
                    this.selectedOption.label,
                    this.encoder.parseBooleans(this.gridApi.getFilterModel()),
                    GridUtils.getSortValue(this.gridApi.getSortModel()),
                    columns,
                    this._getSelectedEntityIds(),
                    this.selectedOption.url,
                    this.sectionIds,
                    exportType)
            }
            return null
        },

        showTechModal() {
            if (this.selectedRows.length) {
                const element = this.selectedRows[0]

                let entityToFocus
                if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                    this.casIdAssaysModal = element.sample.caseStudy.casId
                    this.casPriorityAssaysModal = element.sample.caseStudy.priority
                    entityToFocus = [{ label: element.porLabel }]
                } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                    this.casIdAssaysModal = element.portion.sample.caseStudy.casId
                    this.casPriorityAssaysModal = element.portion.sample.caseStudy.priority
                    entityToFocus = [{ label: element.supLabel }]
                } else if (this.selectedOption.type === ENTITIES_LABORATORY.SAMPLE) {
                    this.casIdAssaysModal = element.caseStudy.casId
                    this.casPriorityAssaysModal = element.casePriority
                    entityToFocus = [{ label: element.sampleLabel }]
                }
                this.$nextTick(() => this.$refs.modalAssaysView.show([entityToFocus]))
            }
        }
    }
}
</script>

<style lang="scss">
.empty-box{
    background:grey;
    border-radius:5px;
    opacity: .1;
}

.empty-box.search{
    height: 25px;
    width: 250px;
    background:grey;
    border-radius:5px;
    opacity: .1;
}

.empty-box.buttons{
    height: 25px;
    width: 25px;
}

.empty-box.header{
    height: 40px;
    background:grey;
    border-radius:2px;
    opacity: .08;
}

.laboratory-empty-state {
    height: calc(100vh - 190px);
    background:linear-gradient(to top, rgba(196,196,196,0), rgba(196,196,196,.2));
    border-radius:2px;
}

.laboratory-empty-state .picture{
    position:relative;
    height: 150px;
    width: 150px;
}

.laboratory-empty-state .picture img{
    position:relative;
    z-index: 1;
    width: 150px;
}

.laboratory-empty-state .picture .circle {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: vt-color(primary);
    opacity: .2;
    border-radius: 50%;
    z-index: 0;
}

.laboratory-empty-state h3 {
    font-size: 22px;
    color: vt-color(dark-text);
}

.laboratory-module .modal-instrument .modal-content {
    top: 45px !important;
    height: calc(100vh - 75px);
}

.laboratory-grid .vertical-line-lab {
  height: 16px;
  width: 1px;
  background: vt-color(base-text, 0.6);
}

.laboratory-grid .action-btn .btn i {
  font-size: font-size(big);
}

.laboratory-grid .btn-separator {
  border: 1px solid vt-color(light-primary);
  padding: 0 0;
  margin: 0 1rem;
}

.laboratory-grid .multiselect__content-wrapper {
    width: auto;
    min-width: 200px;
}

.laboratory-grid {
  height: 100%;
  display: flex;
    flex-direction: column;
}

.laboratory-grid .laboratory-sample-grid {
    height: 100%;
}

.laboratory-grid .grossing-sample-page {
  display: flex;
}

.laboratory-grid .sr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem;
  flex-shrink: 0;
}

.laboratory-grid .sr-header-buttons {
  margin-right: 1.5em;
}

.laboratory-grid .lab-action {
    font-size: 18px;
}

</style>

<style lang="scss" scoped>

.offscreen {
    position: absolute;
    left: -9999px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
}

.switch::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}

input[type='checkbox']:checked + .switch::after {
    transform: translateX(20px);
}

input[type='checkbox']:checked + .switch {
    background-color: vt-color(primary);
}

</style>
